import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const Piechart2 = (prop) => {
  const COLORS = ["#8884d8", "#9CAFAA", "#ACE2E1", "#67C6E3", "#9BB0C1"];

  return (
    <React.Fragment>
      <ResponsiveContainer width="100%" height={225}>
        <PieChart width={400} height={400}>
          <Pie
            data={prop.dataPie}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={30}
            outerRadius={80}
            paddingAngle={1}
            labelLine={false} // ✅ ให้มีเส้นลากออกจากชิ้นกราฟ
            label={({
              cx,
              cy,
              midAngle,
              innerRadius,
              outerRadius,
              value,
              index,
            }) => {
              // 🔸 ซ่อน label ถ้าค่าเปอร์เซ็นต์เล็กกว่า 3%
              if (value < 1) return null;

              const RADIAN = Math.PI / 180;

              // 🔸 ปรับระยะห่างของ label ทีละ index เพื่อลดการซ้อน
              const offset = index * 4;
              const radius =
                innerRadius + (outerRadius - innerRadius) * 1.2 + offset;

              const x = cx + radius * Math.cos(-midAngle * RADIAN);
              const y = cy + radius * Math.sin(-midAngle * RADIAN);

              return (
                <g>
                  <text
                    x={x}
                    y={y}
                    fill="#333"
                    textAnchor={x > cx ? "start" : "end"}
                    dominantBaseline="central"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    {prop.dataPie[index].name} {value}%
                  </text>

                  {/* 🔸 แสดง value2 ด้านล่าง (ถ้ามีค่า) */}
                  {prop.dataPie[index].value2 &&
                    prop.dataPie[index].value2 !== "" && (
                      <text
                        x={x}
                        y={y + 12}
                        fill="#666"
                        textAnchor={x > cx ? "start" : "end"}
                        dominantBaseline="central"
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        ({prop.dataPie[index].value2})
                      </text>
                    )}
                </g>
              );
            }}
          >
            {prop.dataPie.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Piechart2;
